import type { InputTableQuerySpec, Organism } from "@/graphql.ts";

interface SyntenyViewerPayload {
  syntenyGenomeId: Organism["id"];
  organismId: number;
  entityId: number;
  featureType: Pick<InputTableQuerySpec, "resultType" | "resultSubTypeId">;
  viewid: string | undefined;
}

export function openInSyntenyViewerTab(payload: SyntenyViewerPayload) {
  return `/organism/${payload.syntenyGenomeId}/synteny?${payload.viewid ? "viewid=" + payload.viewid + "&" : ""}organismId=${payload.organismId}&entityId=${payload.entityId}&resultType=${payload.featureType.resultType}${payload.featureType.resultSubTypeId ? "&resultSubTypeId=" + payload.featureType.resultSubTypeId : ""}`;
}
